<template>
    <div class="mian_page">
        <div class="desktop-element">
            <div class="page_hx flex-col">
                <my-menu class="sticky-menu" :default-active-index="2"></my-menu>
                <advisory-banner :imageUrl="aboutBanner"></advisory-banner>
                <type-select :selected-index="1" @change="changeType" :key="`type-${Date.now()}-1`"></type-select>
                <div class="div_content">
                    <div class="section_4 flex-row justify-between">
                        <div class="group_13 flex-col">
                            <div class="block_13 flex-row justify-between">
                                <div class="image-text_11 flex-row justify-between">
                                    <img
                                            class="label_1"
                                            referrerpolicy="no-referrer"
                                            src="../../assets/advisory/advisory_select_type1_02.png"
                                    />
                                    <span class="text-group_3">业务合规管理</span>
                                </div>
                                <span class="text_18">Compliance</span>
                            </div>
                            <img
                                    class="image_7"
                                    referrerpolicy="no-referrer"
                                    src="./assets/img/SketchPng058f619c4fb320f70ecaf25f56f7aeef8e86cb75e1a2bd6987e3454070ae04d8.png"
                            />
                            <div class="text-group_19 flex-col justify-between">
                          <span class="text_19">
                            面对医药大健康行业日益复杂的监管环境与多元化营销场景，康柏汉森为企业提供全链条、多维度的合规风控解决方案，覆盖费用审核、活动核查、合规审核等关键场景。支持全国范围内的突击核查，定制化风控核查的需求，助力客户降低合规风险、从容应对政策高压与市场挑战。
                          </span>
                                <span class="text_20">核心产品：费用审核 学协会/基金会核查 尽职调查 讲者核查 会议飞检</span>
                            </div>
                        </div>
                        <div class="block_5_wraper">
                            <div class="block_5 flex-col"  :style="{ backgroundImage: 'url(' + aboutImageUrl + ')' }" ></div>
                        </div>
                    </div>
                    <core-select></core-select>
                    <solve-index></solve-index>
                    <!---->
                    <div class="section_10 flex-col">
                        <div class="block_6 flex-col" :style="{ backgroundImage: 'url(' + imgOrMp4 + ')' }"></div>
                    </div>
                    <div class="section_11 flex-col">
                        <div class="text-wrapper_5">
                            <span class="text_30">“合规为盾，增长为矛”</span>
                            <span class="paragraph_1"><br /></span>
                            <span class="text_31">-&nbsp;康柏汉森助力企业实现风险可控的可持续增长&nbsp;-</span>
                        </div>
                    </div>
                </div>

                <ChpcFooter></ChpcFooter>
                <contact-float v-show="isVisible" @change="change" />
                <contact-dialog v-show="!isVisible" @showContact="showContact"></contact-dialog>
            </div>
        </div>

        <div class="mobile-element">
            <div class="mobile-page flex-col">
                <mobile-header class="sticky-menu-mobile" :default-active-index="2"></mobile-header>
                <div class="mobile-link">
                    <mobile-link :default-active-index="2"></mobile-link>
                    <mobile-banner :contactBanner="aboutBanner"></mobile-banner>
                    <div class="div_type_select">
                        <mobile-type :selected-index="1" @change="changeType" key="mobile2"></mobile-type>
                    </div>
                    <mobile-introduce :introItem="introItem"></mobile-introduce>
                    <mobile-core :core-info="coreData"></mobile-core>
                    <mobile-solve-index></mobile-solve-index>
                    <div class="section_10_mobile flex-col">
                        <div class="block_6_mobile flex-col" :style="imgOrMp4Style"></div>
                    </div>
                    <div class="section_11_mobile flex-col">
                        <div class="text-wrapper_5_mobile">
                            <span class="text_30">“合规为盾，增长为矛”</span>
                            <span class="paragraph_1"><br /></span>
                            <span class="text_31">-&nbsp;康柏汉森助力企业实现风险可控的可持续增长&nbsp;-</span>
                        </div>
                    </div>
                </div>
                <mobile-footer @contactMobile="contactMobile"></mobile-footer>
                <mobile-contact-dialog v-show="isVisibleMobile" @closeMobileContact="closeMobileContact"></mobile-contact-dialog>

            </div>
        </div>
    </div>
</template>
<script>
    import myMenu from "@/views/Component/ChpcMenu.vue";
    import ContactFloat from "@/views/Component/Contact.vue";
    import ContactDialog from "@/views/Component/ContactDialog";
    import advisoryBanner from "./childPage/advisoryBanner";
    import typeSelect from "./childPage/typeSelect";
    import coreSelect from "./childPage/coreCompliance";
    import solveIndex from "./childPage/solveCompliance";
    import ChpcFooter from "@/views/Component/ChpcFooter";
    import TypeSelect from "./childPage/typeSelect";
    //mobile
    import MobileHeader from "@/views/Component/MobileHeader";
    import MobileLink from "@/views/Component/MobileLink";
    import MobileFooter from "@/views/Component/MobileFooter";
    import {isNull} from "../../common/testFun";
    import commonFun from "@/util/common.js";
    import MobileType from "./childPage/MobileType";
    import MobileIntroduce from "./childPage/MobileIntroduce";
    import MobileCore from "./childPage/MobileCore";
    import MobileSolveIndex from "./childPage/MobileSolveCompliance";
    import MobileContactDialog from "@/views/Component/MobileContactDialog";
    import MobileBanner from "./childPage/MobileBanner";

    export default {
        name: "complianceIndex",
        metaInfo:{
            title:'北京康柏汉森医药科技咨询有限责任公司',
            meta:[{name: 'keyWords', content:'官网，CHPC，医药咨询，康柏汉森，医药科技咨询；医药企业营销咨询；企业管理咨询；商务咨询'},
                {name:'description', content:'简称CHPC, CHPC起步于医药行业,中国医药行业内风险控制领域的服务提供商，提供渠道核查、合规核查、信息技术、管理咨询服务'},
                {name:"robots",content:"北京康柏汉森医，业务合规管理"},
            ]
        },
        computed: {
            imgOrMp4Style() {
                return {
                    backgroundImage: `url(${this.imgOrMp4})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat'
                };
            }
        },
        data() {
            return {
                aboutBanner:require('@/assets/advisory/advisory_bj_02.png'),
                aboutImageUrl:require('@/assets/advisory/advisory_select_type_bj02.png'),
                imgOrMp4: require('@/assets/advisory/advisory_index_solve01.png'),
                isVisible:true,
                isVisibleMobile:false,
                currentIndex: 1,
                introItem:{
                    title:'业务合规管理',
                    enTitle:'Compliance',
                    content:'面对医药大健康行业日益复杂的监管环境与多元化营销场景，康柏汉森为企业提供全链条、多维度的合规风控解决方案，覆盖费用审核、活动核查、合规审核等关键场景。支持全国范围内的突击核查，定制化风控核查的需求，助力客户降低合规风险、从容应对政策高压与市场挑战。',
                    production:'核心产品：费用审核 学协会/基金会核查 尽职调查 讲者核查 会议飞检',
                    img:require('@/assets/advisory/advisory_select_type_bj02.png'),
                    labelIcon: require('@/assets/advisory/advisory_select_type1_02.png'),
                },
                coreData: {
                    detailImg: require('../../assets/advisory/advisory_core_select02.png'),
                    items: [
                        {
                            icon: require('../../assets/home/chpc_about_industry_03.png'),
                            text: '全场景覆盖能力',
                            content:'深度渗透学协会、基金会、及CSO组织等高风险环节，提供涵盖费用审核（包含T&E、市场推广费用、对公第三方等）、三方会议资料核查、终端可疑商户走访、尽职调查（DD）等维度的30+专项服务，精准识别业务的合理性、合规性及企业制度遵从性。',
                        },
                        {
                            icon: require('../../assets/home/chpc_about_industry_04.png'),
                            text: '全链路穿透式稽查',
                            content:'服务覆盖“事前-事中-事后”全流程，通过多维度联动核查，精准识别业务链条中的矛盾点与潜在合规风险，为企业保驾护航。例如：针对学术会议，从活动申请、执行、关会到报账进行穿透式核查，核实活动合规性、真实性，以及政策遵从性。',
                        },
                        {
                            icon: require('../../assets/home/chpc_about_industry_05.png'),
                            text: '高度定制化核查服务',
                            content:'基于近二十年合规管理服务经验，能够依据政策变化与最新行业趋势，及时甄别客户业务风险；按需求定制核查范围、深度与周期，提供灵活适配的合规解决方案。例如：针对区域监管差异，定向设计突击检查方案；针对创新业务模式开发专属风险指标库，精准匹配企业战略目标。',
                        },
                        {
                            icon: require('../../assets/home/chpc_about_industry_06.png'),
                            text: '智能化合规工具',
                            content:'自主研发AI智能识别系统高效处理大量底稿、票据等资料；采用智能化项目执行管理、人员排期合理分配人力资源；提升查验效率和精准度；提升风险预警能力。',
                        }
                    ],
                }
            };
        },

        components:{
            TypeSelect,
            myMenu,ChpcFooter,advisoryBanner,typeSelect,coreSelect,solveIndex,ContactDialog,ContactFloat,
            MobileHeader,MobileLink,MobileFooter, MobileType,MobileIntroduce,MobileCore,
            MobileSolveIndex,MobileContactDialog,MobileBanner

        },
        mounted() {
            this.getPic();
        },
        methods: {
            change(){
                this.isVisible = false;
            },
            showContact(){
                this.isVisible = true;
            },
            contactMobile(){
                this.isVisibleMobile = true;
            },
            closeMobileContact(){
                this.isVisibleMobile = false;
            },
            changeType(index) {
                if(index == 0){
                    this.goto("Advisory");
                }else if(index == 1){
                    this.goto("compliance");
                }else if(index == 2){
                    this.goto("consultation");
                }
            },
            goto(url){
                url = '/' + url;
                this.$router.push(url);
            },
            getPic(){
                let pic ={model:3}
                this.$HTTP.getPicByModel(pic).then(resp => {
                    if(resp.code == 200){
                        let data = resp.data;
                        if(data && data.length>0){
                            let picarr= commonFun.dealPic(data,1,false);
                            if(picarr && picarr.length>0){
                                this.aboutBanner = picarr;
                            }
                            let aboutImg = commonFun.dealPic(data,3,false);
                            if(!isNull(aboutImg)){
                                this.aboutImageUrl = aboutImg;
                            }
                            let aboutImg5 = commonFun.dealPic(data,5,false);
                            if(!isNull(aboutImg5)){
                                this.imgOrMp4 = aboutImg5;
                            }
                        }
                    }
                });
            }
        }
    };
</script>
<style scoped lang="css" src="./css/index.css" />
